import { useState } from "react";
import { LogInStep } from "./login/LogInStep";
import { RecoverySuccess } from "./login/RecoverySuccess";
import { useLocation, useNavigate } from "react-router-dom";
import { RecoverPassword } from "./login/RecoverPassword";
import { ResetPasswordStep } from "./login/ResetPasswordStep";
import { useAuthMutations } from "../hooks/useAuthMutations";

export default function LoginFlow() {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [step, setStep] = useState("login");
  const [showSuccess, setShowSuccess] = useState(false);
  const { loginAsync, isLoggingIn, loginError } = useAuthMutations();
  const [error, setError] = useState("");

 

const handleLogin = async ({ identifier, password }) => {
  try {
    setError("");

    const result = await loginAsync({ identifier, password });

    const role =
      result?.user?.role ||
      result?.role ||
      result?.data?.user?.role ||
      result?.data?.role;

    if (role === "admin") {
      navigate("/admin", { replace: true });
      return;
    }

    navigate(location.state?.from || "/home", { replace: true });
  } catch (err) {
    setError(err.message || "Invalid email or password");
  }
};

  const handleComplete = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      // Reset revokes all sessions — send them to log in with the new password.
      navigate("/login", { replace: true });
      setStep("login");
    }, 1500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center w-[100%] bg-gray-50 p-0 sm:p-4">
      <div className="w-full max-w-[450px] bg-transparent min-h-screen sm:h-full shadow-xl sm:shadow-none relative overflow-hidden">

        <div
          key={step}
          className="flex-grow animate-in fade-in slide-in-from-right-8 transition duration-500 ease-out"
        >
          {step === "login" && (
            <LogInStep
              onForgot={() => setStep("recover")}
              onSubmit={handleLogin}
              loading={isLoggingIn}
              error={error || (loginError ? (loginError.message || "Invalid credentials") : "")}
            />
          )}

          {step === "recover" && (
            <RecoverPassword
              onBack={() => setStep("login")}
              onSent={(emailValue) => {
                setEmail(emailValue);
                setStep("reset");
              }}
            />
          )}

          {step === "reset" && (
            <ResetPasswordStep
              email={email}
              onBack={() => setStep("recover")}
              onDone={handleComplete}
            />
          )}

          {showSuccess && <RecoverySuccess />}
        </div>
      </div>
    </div>
  );
}
